<template>
  <div id="app">
    <top v-if="showTop"></top>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/views/top'
import bottom from '@/views/bottom'

export default {
  name: 'App',
  data() {
    return {
      showTop: false,
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.path = val.path
        if (
          this.path == '/managerhome' ||
          this.path == '/homeStationClassify' ||
          this.path == '/BottomInfo' ||
          this.path == '/BigData'
        ) {
          this.showTop = false
        } else {
          this.showTop = true
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  components: {
    top,
    bottom,
  },
  mounted() {},
}
</script>

<style>
.coverimg-big {
  display: inline-block;
  max-width: 600px;
  max-height: 600px;
  width: auto;
  height: auto;
}
.el-message {
  top: 45% !important;
}
.el-message .el-icon-success {
  color: #67c23a;
  font-size: 28px;
}
.el-message .el-icon-warning {
  color: #e6a23c;
  font-size: 28px;
}
.el-message .el-icon-error {
  color: #f56c6c;
  font-size: 28px;
}
</style>
<style lang="scss">
#app {
  color: #333;
  height: 100%;
  background: #fff;
  position: relative;
  font-size: 16px;
  --main-color: #e68422;
}
.el-tooltip__popper {
  max-width: 800px;
}
.tabSearch {
  margin: 20px 0;
  ul {
    li {
      border: 1px solid #e6e6e6;
      padding: 10px 20px;
      cursor: pointer;
      color: #666;
      &:nth-of-type(2),
      &:nth-of-type(3),
      &:nth-of-type(4),
      &:nth-of-type(5) {
        border-left: none;
      }
      i {
        color: #cccccc;
        margin-left: 5px;
      }
    }
    .checked {
      background: #e68422;
      border: 1px solid #e68422;
      color: #fff;
      i {
        color: #fff;
      }
    }
  }
  .searchFor {
    margin-left: auto;
    position: relative;
    display: flex;
    align-items: center;
    .el-input {
      width: 250px;
      .el-input__inner {
        border-radius: 0;
      }
    }
    > span {
      background: #e68422;
      color: #fff;
      height: 40px;
      width: 70px;
      cursor: pointer;
      i {
        font-size: 23px;
      }
    }
  }
}
.noData {
  text-align: center;
  margin-top: 40px;
  padding-bottom: 80px;
  p {
    margin-top: 10px;
  }
}
.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 22px;
}

.line2 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  /* -webkit-box-orient: vertical; */
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  display: -webkit-box;
  word-break: break-all;
}
.message-box {
  /deep/ .el-icon-warning {
    color: #f56c6c !important;
  }
  .el-icon-warning {
    color: #f56c6c !important;
  }
  button:first-child:hover {
    color: unset;
    background-color: unset;
    border-color: unset;
    border: 1px solid #dcdfe6;
  }
  .el-button--primary {
    background-color: #43aad3 !important;
    border-color: #43aad3 !important;
    &:hover {
      background-color: #43aad3 !important;
      border-color: #43aad3 !important;
    }
  }
}
.el-message-box__status.el-icon-warning {
  color: #f56c6c !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue